/**
 * Strings UI centralizadas (es-CL) para el customer SPA.
 */
export const t = {
  app: {
    title: 'ZEngine',
    loading: 'Cargando…',
    error: 'Ocurrió un error',
    retry: 'Reintentar',
    logout: 'Cerrar sesión',
    todoBackend: 'TODO: backend endpoint pendiente — datos de ejemplo.',
  },
  nav: {
    dashboard: 'Dashboard',
    conexiones: 'Conexiones',
    campanas: 'Campañas',
    templates: 'Templates',
    variables: 'Variables',
    reportes: 'Reportes',
    estado: 'Estado de plataforma',
    config: 'Configuración',
  },
  topbar: {
    env: 'Producción',
    notifications: 'Notificaciones',
    help: 'Ayuda',
  },
  login: {
    redirecting: 'Redirigiendo al inicio de sesión…',
  },
  callback: {
    processing: 'Procesando autenticación…',
    missingTokens: 'No se recibieron tokens válidos',
    retry: 'Reintentar inicio de sesión',
    retrying: 'La sesión se perdió. Reiniciando login…',
  },
} as const;
